export default "__VITE_ASSET__yT1YVipT__"